import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import React from "react";
import { BUTTON_PROPS } from "./vars";

const ThemedButton = createThemedComponent(Button, BUTTON_PROPS);

export default function ToolbarButton({ icon, label, onClick, disabled }) {
  return (
    <ThemedButton
      iconStart={icon}
      color="white"
      naked
      label={label}
      onClick={onClick}
      disabled={disabled}
    />
  );
}
